import angular from 'angular';
import orderHistoryComponent from './order-history.component';
import orderHistoryResolver from './order-history-resolver';
import ngRoute from 'angular-route';


let orderHistoryModule = angular.module('order-history', [
        ngRoute
    ])

        .config(($routeProvider) => {
        "ngInject";

var historyUrl = '/bathrooms/cart/orders';

$routeProvider
    .when(historyUrl,{
        template: '<order-history order-history-model="$resolve.orderHistoryModel"></order-history>',
        resolve: orderHistoryResolver
    });
})
.component('orderHistory', orderHistoryComponent);

export default orderHistoryModule;


// WEBPACK FOOTER //
// ./src/app/components/order-history/order-history.js